
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import {en} from '@/locales/en';
import {CONF} from '@/constants/conf';


Vue.use(VueI18n);
export const i18n = new VueI18n({
    locale: CONF.LANGUAGE_DEFAULT, // set locale
    fallbackLocale: CONF.LANGUAGE_FALLBACK, // set Fallback Language
    messages: {en}, // set locale messages
});

